function Footer() {
  return (
    <footer className="footer dreamscape-footer">
      <span className="footer-note">
        Made with <span role="img" aria-label="love">❤️</span> by{" "}
        <a
          href="https://github.com/Irtaza2009"
          target="_blank"
          rel="noopener noreferrer"
          className="github-link"
        >
          Irtaza
        </a>
      </span>
    </footer>
  );
}

export default Footer;
